import { Box } from "@chakra-ui/react"
import React, { useGlobal, useEffect } from "reactn"
import debounceEffect from '../utils/debounceEffect'

const CartError = () => {
  const [cartError, setCartError] = useGlobal("cartError")
  const debouncedCartError = debounceEffect(cartError, 3000)

  useEffect(() => {
    if (cartError) {
      setCartError("")
    }
  }, [debouncedCartError])

  return (
    <>
      {cartError && (
        <Box
          bg="red.50"
          border="1px solid"
          borderColor="red.200"
          color="red.700"
          px={4}
          py={3}
          mb={3}
          fontSize="14px"
          borderRadius="4px"
          textAlign="left"
        >
          {cartError}
        </Box>
      )}
    </>
  )
}

export default CartError